import { DaysOfWeekData } from './localData/daysOfWeekData';

export default (momentInstance, dateIndex, t) => `${momentInstance.format('DD MMM')}, ${t(DaysOfWeekData[momentInstance.day()])} ${dateIndex === 0 ? `(${t('today')})` : dateIndex === 1 ? `(${t('tomorrow')})` : ''}`;
